<template>
  <button
    class="btn"
    :class="clsx({
      'btn--loading': isLoading,
      'btn--disabled': isDisabled,
      [`btn--size-${size}`]: true,
    })"
    :disabled="isDisabled || isLoading"
    v-on="$listeners"
  >
    <span class="btn__label" v-if="!isLoading">
      <slot></slot>
    </span>

    <span class="btn__loader" v-if="isLoading">
      <SpinnerLoader color="#0A77FF" />
    </span>
  </button>
</template>

<script>
import clsx from 'clsx';
import { SpinnerLoader } from '@/shared/ui/loader';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'small', 'large'].includes(value),
    },
  },
  components: { SpinnerLoader },
  methods: { clsx },
};
</script>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #0A77FF;
  font-family: inherit;
  font-weight: 500;
  color: #FAFAFA;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  white-space: nowrap;
}

.btn:hover:not(:disabled) {
  opacity: 0.9;
  color: #FAFAFA;
}

.btn:active:not(:disabled) {
  opacity: 0.8;
}

.btn:focus {
  outline: none;
}

.btn--size-default {
  padding: 16px 24px;
  font-size: 16px;
}

.btn--size-small {
  padding: 8px 12px;
  font-size: 14px;
}

.btn--size-large {
  padding: 20px 32px;
  font-size: 18px;
}

.btn:disabled,
.btn--disabled,
.btn--loading {
  cursor: not-allowed;
  pointer-events: none;
  background-color: #F6F6F9;
  color: #717680;
}

.btn__label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn__loader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
